import { Link } from "react-router-dom";

export default function PageHero({ eyebrow, title, subtitle, breadcrumbs = [], image }) {
  return (
    <section className="relative bg-charcoal text-white overflow-hidden">
      {image && (
        <div className="absolute inset-0 opacity-25">
          <img src={image} alt="" className="w-full h-full object-cover" />
          <div className="absolute inset-0 bg-gradient-to-r from-charcoal via-charcoal/85 to-charcoal/40" />
        </div>
      )}
      <div className="grain-overlay" />
      <div className="relative max-w-[1400px] mx-auto px-6 lg:px-12 py-24 lg:py-32">
        <div className="max-w-3xl">
          {eyebrow && <div className="overline mb-6">{eyebrow}</div>}
          <h1 className="font-heading text-4xl md:text-5xl lg:text-6xl font-semibold tracking-tight leading-[1.05]">
            {title}
          </h1>
          {subtitle && (
            <p className="mt-6 text-base md:text-lg text-white/75 max-w-2xl leading-relaxed">{subtitle}</p>
          )}
          {breadcrumbs.length > 0 && (
            <div className="mt-10 font-mono text-[11px] uppercase tracking-[0.24em] text-white/50 flex flex-wrap gap-2">
              {breadcrumbs.map((b, i) => (
                <span key={i} className="flex items-center gap-2">
                  {b.to ? (
                    <Link to={b.to} className="hover:text-gold transition-colors">{b.label}</Link>
                  ) : (
                    <span className="text-gold">{b.label}</span>
                  )}
                  {i < breadcrumbs.length - 1 && <span>/</span>}
                </span>
              ))}
            </div>
          )}
        </div>
      </div>
    </section>
  );
}
